import React from "react";

export default class BadTrip extends React.Component {
  render() {
    return (
      <>
        <h3>Symptoms</h3>
        <p>
          A person is disoriented, scared, nervous, tangled, often present are
          somatic symptoms related to the subjective perception of heart or
          respiratory system failure, in extreme cases with accompanying
          sensation of dying.
        </p>
        <p>
          If those symptoms are a result of ingesting a psychoactive substance,
          we are dealing with a difficult experience, commonly called "a bad
          trip”.
        </p>
        <h3>What to do?</h3>
        <h3>5 groundrules of tripsitting:</h3>
        <h4>#0 Is everything OK physically?</h4>
        <p>
          The zero rule should precede every tripsitting - make sure (both
          through looking around and through what the person is saying), that
          everything is fine physically. Try to get to know what the person
          assumes to have taken, when, and what dose. If you have any concerns
          at this stage, don't hesitate to call for help.
        </p>
        <h4>#1 Create safe space </h4>
        <p>
          A crowd is the last thing you want. If the person you are helping is
          bringing attention with own behaviour, go to a more secluded space (to
          the extent that it's possible). Be a safe space yourself - don't do
          any nervous moves, touch softly, touch builds trust and a feeling of
          safety. Mantain contact and and take care of thermic comfort (i.e.
          cover up with a blanket or a coat). You can serve warm tea or water,
          but avoid stimulating drinks (cofee and "energy drinks") and alcohol,
          to avoid unintented interactions.
        </p>
        <h4>#2 Sitting, not guiding </h4>
        <p>
          The key is to ensure mental comfort to the person going through a
          difficult experience. You should move with warm, calm and a steady
          voice, don't be nervous. Try to steer the conversation in a positive
          side, but in the way that ensures, that the experience could remain
          unfolding on it's own. Don't interpret for a person, don't suggest any
          thoughts. Mirror and remember, that the fact that you are sitting and
          taking care of is already very helpfull.
        </p>
        <h4>#3 Talk through, not down</h4>
        <p>
          Don't make the experience any more real and don't question it! If a
          person sees something as scary, don't question it, (nor the fact of
          it's existence) - that way you would only increase fear (creating a
          conflict between what you say and what the person percieves) and you
          will loose the trust of the person you are helping. Instead, keep
          asking for example how is a terrifying object can be dangerous and if
          for sure. Build faint in capacity to go through the experience, remind
          that it is going to end. Try to not intensify. don't enrich the
          lights, don't show fractal paintings, don't make anything up.
        </p>
        <h4>#4 Difficult is not the same as bad</h4>
        <p>
          Avoid the term Bad Trip. The fact that the experience is difficult
          doesn't come from nowhere, sometimes it's good to change fear into
          curiosity. Most often the reason behind difficulities is an incorect
          set (attitude towards the experience), setting (environment that the
          person is tripping in) or a general emotional tension typical for
          experiences such like that. Encourage the person to take a look at the
          difficulities and analyze them, suggesting that it might reveal more
          than expected.
        </p>
        <h4>#Additional tips</h4>
        <p>
          -If you see, that a person is begining to hyperventilate (breath fast
          and nervous), show the correct breath rate and ask, to breath with you
          at the same tempo. If that doesn't help, hand a paper bag to breath.
          Breathing several times with the same air from the bag will reduce the
          unwatned surplus of oxygen in the body.
        </p>
        <p>
          -It's handy to keep your hands busy - use a toy of a rare texture or
          softness. If you have acess to art supplies, ask if the person
          wouldn't care to bring the experience onto paper.
        </p>
        <p>
          -Don't panic. If you are afraid or you know, that you can't handle the
          situation, ask someone experienced for help. Your stress might spread
          onto the person you are helping and increase the sensation of fear.
          don't do anything that you wouldn't feel alright with.
        </p>
        <p>-If anything or anyone begins to threaten your safety, back away.</p>
      </>
    );
  }
}
